
import Vue from "vue";
import { NewAlertSettingsApiFunc, setAccessToken } from "@/api";
import { FailureAlertSetting, LongStayAlertSetting, LowBatteryAlertSetting } from "@/models";

import TheTemplate from "../TheTemplate.vue";
import FailureAlertSettingEditor from "./components/FailureAlertSettingEditor.vue";
import LongStayAlertSettingEditor from "./components/LongStayAlertSettingEditor.vue";
import LowBatteryAlertSettingEditor from "./components/LowBatteryAlertSettingEditor.vue";

export type DataType = {
  failureAlertSetting?: FailureAlertSetting;
  longStayAlertSetting?: LongStayAlertSetting;
  lowBatteryAlertSetting?: LowBatteryAlertSetting;
  longStayLoading: boolean;
  longStayChecked: boolean;
  lowBatteryLoading: boolean;
  lowBatteryChecked: boolean;
};

export default Vue.extend({
  name: "AlertSettingListScreen",

  data(): DataType {
    return {
      failureAlertSetting: undefined,
      longStayAlertSetting: undefined,
      lowBatteryAlertSetting: undefined,
      longStayLoading: false,
      longStayChecked: false,
      lowBatteryLoading: false,
      lowBatteryChecked: false,
    };
  },

  mounted() {
    this.getFailureAlertSetting();
    this.getLongStayAlertSetting();
    this.getLowBatteryAlertSetting();
  },

  components: {
    TheTemplate,
    FailureAlertSettingEditor,
    LongStayAlertSettingEditor,
    LowBatteryAlertSettingEditor,
  },

  methods: {
    async getFailureAlertSetting(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewAlertSettingsApiFunc().getFailureAlertSetting(companyId);
      if (err != null) {
        this.$handleApiError(err, this.getFailureAlertSetting);
        return;
      }

      this.failureAlertSetting = data;
    },

    async getLongStayAlertSetting(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewAlertSettingsApiFunc().getLongStayAlertSetting(companyId);

      if (err != null) {
        this.$handleApiError(err, this.getLongStayAlertSetting);
        return;
      }

      this.longStayAlertSetting = data;
    },

    async getLowBatteryAlertSetting(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewAlertSettingsApiFunc().getLowBatteryAlertSetting(companyId);

      if (err != null) {
        this.$handleApiError(err, this.getLowBatteryAlertSetting);
        return;
      }

      this.lowBatteryAlertSetting = data;
    },

    async updateLongStayAlertSetting(alertSetting: LongStayAlertSetting): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      this.longStayLoading = true;

      setAccessToken(this.$auth.accessToken);
      const { err } = await NewAlertSettingsApiFunc().updateLongStayAlertSetting(companyId, alertSetting);
      if (err != null) {
        this.$handleApiError(err, () => {
          this.updateLongStayAlertSetting(alertSetting);
        });
        this.longStayLoading = false;
        return;
      }

      this.longStayLoading = false;
      this.longStayChecked = true;
      const showCheckSeconds = 2000;
      setTimeout(() => {
        this.longStayChecked = false;
      }, showCheckSeconds);
    },

    async updateLowBatteryAlertSetting(alertSetting: LowBatteryAlertSetting): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      this.lowBatteryLoading = true;
      setAccessToken(this.$auth.accessToken);
      const { err } = await NewAlertSettingsApiFunc().updateLowBatteryAlertSetting(companyId, alertSetting);
      if (err != null) {
        this.$handleApiError(err, () => {
          this.updateLongStayAlertSetting(alertSetting);
        });
        this.lowBatteryLoading = false;
        return;
      }

      this.lowBatteryLoading = false;
      this.lowBatteryChecked = true;
      const showCheckSeconds = 2000;
      setTimeout(() => {
        this.lowBatteryChecked = false;
      }, showCheckSeconds);
    },
  },
});
